import React from 'react';
import { Badge } from './Primitives';
import { originMeta, deriveOrigins } from '../utils/format';

/**
 * Badge delle sorgenti modificate di una macrofunzione.
 *
 * Fonte primaria: `item.changeSummary.sources` (contratto aggiornato), che
 * elenca tutte le famiglie modificate nel periodo con la relativa azione.
 * Fallback sicuro: `deriveOrigins(item)` per risposte backend precedenti prive
 * di changeSummary.
 */
export default function ChangeSourceBadges({ item }) {
  const sources = item?.changeSummary?.sources;

  if (Array.isArray(sources) && sources.length > 0) {
    return (
      <div className="flex flex-wrap gap-1">
        {sources.map((s, i) => {
          // Per le cancellazioni usa la variante "*Deleted" se disponibile.
          const deletedKey = `${s.source}Deleted`;
          const metaKey =
            s.action === 'DELETE' && originMeta(deletedKey) ? deletedKey : s.source;
          const meta = originMeta(metaKey);
          if (!meta) return null;
          const title =
            s.action === 'DELETE'
              ? `Rimozione · ${meta.label}`
              : `Modifica · ${meta.label}`;
          return (
            <Badge key={`${s.source}-${i}`} className={meta.style} title={title}>
              {meta.label}
            </Badge>
          );
        })}
      </div>
    );
  }

  // Fallback: origini dedotte dai timestamp (backend legacy).
  const origins = deriveOrigins(item);
  return (
    <div className="flex flex-wrap gap-1">
      {origins.map((key) => {
        const meta = originMeta(key);
        if (!meta) return null;
        return (
          <Badge key={key} className={meta.style} title={`Motivo modifica: ${meta.label}`}>
            {meta.label}
          </Badge>
        );
      })}
    </div>
  );
}
